import { render, staticRenderFns } from "./OddsEventsGroup.vue?vue&type=template&id=4136e54e"
import script from "./OddsEventsGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./OddsEventsGroup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports